//
// # Routing Module
//
// Wire routing algorithms for schematic editing.
//

export {
  ManhattanRouter,
  pathToSegments,
  countBends,
  segmentCrossesBbox,
  DEFAULT_ROUTER_CONFIG,
  type RouterConfig,
  type RouteResult,
  type RouteOptions,
  type FirstLeg,
} from "./manhattan_router";

export {
  planCleanupEdits,
  planWireEdits,
  type PlannedWire,
  type WireEdit,
} from "./wire_plan";

export {
  buildConnectivity,
  type ConnectivityIndex,
  type SegmentLike as ConnectivitySegment,
} from "./connectivity";

export {
  checkWireInvariants,
  describeWireViolations,
  type Violation,
  type ViolationKind,
  type CheckOptions,
} from "./invariants";

export {
  pointKey,
  getSchPinWorldLocation,
  SCHEMATIC_GRID_SIZE,
  SCHEMATIC_BEND_COST,
} from "./wire_utils";

export {
  PIN_SNAP_RADIUS,
  buildPinLocationCache,
  findNearestPin,
  isAtPin,
  snapToNearbyPin,
  type PinSnapResult,
  type PinLocationCache,
} from "./pin_snap";
